// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MacCommandFilledSvg from "@ant-design/icons-svg/es/asn/MacCommandFilled";
import AntdIcon from '../components/AntdIcon';

var MacCommandFilled = function MacCommandFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MacCommandFilledSvg
  }));
};

MacCommandFilled.displayName = 'MacCommandFilled';
export default React.forwardRef(MacCommandFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MacCommandFilled.js
// module id = 1441
// module chunks = 0